import React from "react";
import {toJS} from 'mobx';
import {observer, inject} from 'mobx-react';

import {getColorByQCFlag, returnFullQcFlag} from "../../../utils";
import Form, {SelectInput, TextInput} from "../../Form";
import {observation as api} from "../../../actions/api";

@inject('hqcStore')
@observer
export default class SelectedObservationQcTable extends React.Component {
  state = {
    hqcFlag: '',
    value: ''
  };

  render() {
    const {hqcStore, spaceForPin, flags, getQcFlagEntryByFlag} = this.props;
    const {hqcFlag, value} = this.state;

    const {
      getCombinedTimeData,
      setObservations,
      observations,
      setSelectedObservations,
      selectedObservations,
      editHQC,
      setEditHQC,
      editValue,
      setEditValue,
      selectedDataSeries,
      pinned,
    } = hqcStore;

    if (selectedObservations.length > 0) {
      return <div style={{position: 'sticky', top: spaceForPin && pinned ? 400 : 0}}><Form>
        {editHQC ? <SelectInput value={hqcFlag}
                                label={'New HQC Flag'}
                                id={'HQC Flag'}
                                options={flags.map(({id, caption, color, description}) => ({
                                  id,
                                  caption,
                                  description: `${caption}: ${description}`,
                                  color
                                }))}
                                fields={{label: 'description', value: 'caption'}}
                                onChange={(e) => this.setState({hqcFlag: e.target.value})}/> :
          editValue ? <TextInput value={value} label={"Value"}
                                 onChange={(e) => this.setState({value: e.target.value})}/> :
            <table style={{textAlign: 'center', width: '100%'}}>
              <thead>
              <tr>
                <th colSpan={5} style={{
                  textAlign: 'center',
                  position: 'sticky',
                  top: 0,
                  backgroundColor: '#3c8dbc'
                }}>Selected Observations
                </th>
              </tr>
              <tr>
                <th style={{
                  textAlign: 'center',
                  top: 28,
                  backgroundColor: '#3c8dbc',
                  position: 'sticky'
                }}>Value
                </th>
                <th style={{
                  textAlign: 'center',
                  top: 28,
                  backgroundColor: '#3c8dbc',
                  position: 'sticky'
                }}>HQC
                </th>
                <th style={{
                  textAlign: 'center',
                  top: 28,
                  backgroundColor: '#3c8dbc',
                  position: 'sticky'
                }}>QC2
                </th>
                <th style={{
                  textAlign: 'center',
                  top: 28,
                  backgroundColor: '#3c8dbc',
                  position: 'sticky'
                }}>QC1
                </th>
                <th style={{
                  textAlign: 'center',
                  top: 28,
                  backgroundColor: '#3c8dbc',
                  position: 'sticky'
                }}>QC0
                </th>
              </tr>
              </thead>
              <tbody>
              {selectedObservations.map(item => {
                const flag = returnFullQcFlag(`${item.qc_flag}`);
                const qcFlag = flag ? getQcFlagEntryByFlag(flag[0]) : null;

                return <tr key={item.id}>
                  <td>{item.value}</td>
                  <td style={{
                    backgroundColor: editHQC ? 'white' : getColorByQCFlag(flag[0], getQcFlagEntryByFlag),
                    boxShadow: editHQC ? `inset 0 0 10px ${getColorByQCFlag(hqcFlag, getQcFlagEntryByFlag)}` : '0',
                    color: +flag[0] ? 'white' : 'black'
                  }}>
                    {flag[0]} ({qcFlag.description})
                  </td>
                  <td style={{
                    backgroundColor: getColorByQCFlag(flag[1], getQcFlagEntryByFlag),
                    color: +flag[1] ? 'white' : 'black'
                  }}>{flag[1]}</td>
                  <td style={{
                    backgroundColor: getColorByQCFlag(flag[2], getQcFlagEntryByFlag),
                    color: +flag[2] ? 'white' : 'black'
                  }}>{flag[2]}</td>
                  <td style={{
                    backgroundColor: getColorByQCFlag(flag[3], getQcFlagEntryByFlag),
                    color: +flag[3] ? 'white' : 'black'
                  }}>{flag[3]}</td>
                </tr>
              })}
              </tbody>
            </table>
        }

        <div style={{
          display: 'flex',
          justifyContent: 'space-between',
          position: 'sticky',
          bottom: 0,
          backgroundColor: 'white'
        }}>
          {!editHQC && <button onClick={(e) => {
            e.preventDefault();

            const newEdit = !editValue;

            if (!newEdit) {
              /*global event, fdescribe*/
              /*eslint no-restricted-globals: ["error", "event", "fdescribe"]*/
              if (confirm('Save?')) {
                this.loading = true;

                const payload = {};
                const updateObservations = selectedObservations.map(item => {
                  const {id, qc_flag, series_id, time} = item;
                  const flag = returnFullQcFlag(`${qc_flag}`);

                  return {
                    id: +id,
                    value,
                    qc_flag: +`2${flag[1]}${flag[2]}${flag[3]}`,
                    series_id, time
                  };
                });

                if (selectedDataSeries && selectedDataSeries[0] && selectedDataSeries[0].table) {
                  payload[selectedDataSeries[0].table] = updateObservations;
                } else {
                  payload['0'] = updateObservations;
                }

                let updatedSelectedObservations = selectedObservations.map(item => {
                  const {value, qc_flag, ...others} = item;
                  const flag = returnFullQcFlag(`${qc_flag}`);

                  return {
                    ...others,
                    value: this.state.value,
                    qc_flag: +`2${flag[1]}${flag[2]}${flag[3]}`
                  };
                });

                api.updateMultiple(payload).then(res => {
                  // notify.success({message: 'Saved.'});
                  setSelectedObservations(updatedSelectedObservations);

                  const newObservations = toJS(observations).map(o => {
                    return {
                      series_id: o.series_id,
                      arr: o.arr.map(a => {
                        const payloadItem = updatedSelectedObservations.find(i => +i.id === +a.id);

                        if (payloadItem) {
                          const {value, qc_flag, ...others} = a;
                          const flag = returnFullQcFlag(`${qc_flag}`);

                          return {
                            ...others,
                            value: payloadItem.value,
                            qc_flag: +`2${flag[1]}${flag[2]}${flag[3]}`
                          };
                        } else
                          return {...a};
                      })
                    };
                  });

                  setObservations(newObservations);

                  getCombinedTimeData();

                  setEditValue(newEdit);
                }).catch(err => {
                  setEditValue(newEdit);

                  // notify.error(err)
                });
              }
            } else {
              setEditValue(newEdit);
            }
          }}>{editValue ? 'Save Value' : 'Edit Value'}</button>}
          {!editValue && <button onClick={(e) => {
            e.preventDefault();

            const newEdit = !editHQC;

            if (!newEdit) {
              /*global event, fdescribe*/
              /*eslint no-restricted-globals: ["error", "event", "fdescribe"]*/
              if (confirm('Save?')) {
                this.loading = true;

                const payload = {};
                const updateObservations = selectedObservations.map(item => {
                  const {id, value, series_id, time} = item;
                  const flag = returnFullQcFlag(`${item.qc_flag}`);

                  return {
                    id: +id,
                    value, series_id, time,
                    qc_flag: +`${this.state.hqcFlag}${flag[1]}${flag[2]}${flag[3]}`
                  };
                });

                if (selectedDataSeries && selectedDataSeries[0] && selectedDataSeries[0].table) {
                  payload[selectedDataSeries[0].table] = updateObservations;
                } else {
                  payload['0'] = updateObservations;
                }

                let updatedSelectedObservations = selectedObservations.map(item => {
                  const {qc_flag, ...others} = item;
                  const flag = returnFullQcFlag(`${item.qc_flag}`);

                  return {
                    ...others,
                    qc_flag: +`${this.state.hqcFlag}${flag[1]}${flag[2]}${flag[3]}`
                  };
                });

                api.updateMultiple(payload).then(res => {
                  // notify.success({message: 'Saved.'});
                  setSelectedObservations(updatedSelectedObservations);
                  const newObservations = toJS(observations).map(o => {
                    return {
                      series_id: o.series_id,
                      arr: o.arr.map(a => {
                        const payloadItem = updatedSelectedObservations.find(i => +i.id === +a.id);

                        if (payloadItem) {
                          const {qc_flag, ...others} = a;

                          return {
                            ...others,
                            qc_flag: payloadItem.qc_flag
                          };
                        } else
                          return {...a};
                      })
                    };
                  });

                  setObservations(newObservations);

                  getCombinedTimeData();

                  setEditHQC(newEdit);
                }).catch(err => {
                  setEditHQC(newEdit);

                  // notify.error(err)
                });
              }
            } else {
              setEditHQC(newEdit);
            }
          }}>{editHQC ? 'Save HQC Flag' : 'Edit HQC Flag'}</button>}

          {(editHQC || editValue) && <button onClick={() => {
            setEditHQC(false);
            setEditValue(false);
          }}>Discard</button>}
        </div>
      </Form></div>
    } else {
      return null;
    }
  }
}



// WEBPACK FOOTER //
// ./src/components/HQC/_commons/SelectedObservationQcTable.js